import { IRootState } from "app/model"
import { MessageCenter } from "message/components/MessageCenter"
import React from "react"
import { connect } from "react-redux"
import { MAIN_LAYOUT_ID, MENU_CLOSED_WIDTH_IN_REM, MENU_OPENED_WIDTH_IN_REM } from "ui/model"
import { FlexBox } from "../FlexBox"
import { Routes } from "../router/Routes"
import { MenuDesktop } from "./MenuDesktop"

interface IMainLayoutDesktopProps {
  isMenuOpened: boolean
}

const MainLayoutDesktopFn = React.memo(
  ({ isMenuOpened }: IMainLayoutDesktopProps): JSX.Element => (
    <FlexBox
      id={MAIN_LAYOUT_ID}
      fullHeight
      sx={{
        width: "100%",
        minWidth: "100%",
        maxWidth: "100%",
        flexWrap: "nowrap",
        backgroundColor: theme => theme.palette.background.default
      }}>
      <MenuDesktop />
      <FlexBox
        vertical
        fullHeight
        sx={{
          ml: isMenuOpened ? MENU_OPENED_WIDTH_IN_REM : MENU_CLOSED_WIDTH_IN_REM,
          width: `calc(100% - ${isMenuOpened ? MENU_OPENED_WIDTH_IN_REM : MENU_CLOSED_WIDTH_IN_REM})`,
          transition: "all 600ms ease"
        }}>
        <FlexBox
          fullHeight
          sx={{
            width: "100%",
            minWidth: "100%",
            maxWidth: "100%"
          }}
          className="route-container">
          <Routes />
        </FlexBox>
      </FlexBox>
      <MessageCenter />
    </FlexBox>
  )
)

export const MainLayoutDesktop = connect(
  (state: IRootState): IMainLayoutDesktopProps => ({
    isMenuOpened: state.ui.isMenuOpened
  })
)(MainLayoutDesktopFn)
